/**
 * Determine the parameter type based on its properties
 */
export function getParameterType(parameter: any): string {
  if (!parameter.allowableValues) {
    return "unknown"
  }

  // Check if it's a boolean parameter (usually a list with true/false values)
  if (
    parameter.allowableValues.type === "list" &&
    parameter.allowableValues.allowableValues?.length === 2
  ) {
    const values = parameter.allowableValues.allowableValues.map((v: any) =>
      String(v.value).toLowerCase()
    )
    if (values.includes("true") && values.includes("false")) {
      return "boolean"
    }
  }

  // Check if it's a single-select list
  if (
    parameter.allowableValues.type === "list" &&
    !parameter.allowMultipleValues
  ) {
    return "list-single"
  }

  // Check if it's a multi-select list
  if (
    parameter.allowableValues.type === "list" &&
    parameter.allowMultipleValues
  ) {
    return "list-multi"
  }

  // Range type parameters
  if (parameter.allowableValues.type === "range") {
    return "range"
  }

  return parameter.allowableValues.type
}

/**
 * Convert raw Tableau parameter object to our standardized format
 */
export function formatParameter(parameter: any) {
  const paramType = getParameterType(parameter)

  return {
    name: parameter.name,
    currentValue: parameter.currentValue.value,
    dataType: parameter.dataType,
    parameterType: paramType,
    allowableValues:
      parameter.allowableValues ?
        {
          type: parameter.allowableValues.type,
          values:
            parameter.allowableValues.type === "list" ?
              parameter.allowableValues.allowableValues?.map(
                (v: any) => v.value
              )
            : null,
        }
      : null,
  }
}

/**
 * Initialize parameter selection state from parameter list
 */
export function initializeParameterSelections(parameters: any[]) {
  return parameters.reduce(
    (acc, param) => {
      acc[param.name] = param.currentValue
      return acc
    },
    {} as { [key: string]: any }
  )
}
